import { z } from 'zod/v4';
import {
  PlatformFeatureSchema,
  PlatformFeaturesListQuerySchema,
} from '../schemas/platform-feature.js';

export const ListPlatformFeaturesContract = {
  method: 'GET',
  path: '/admin/platform-features',
  query: PlatformFeaturesListQuerySchema,
  response: z.array(PlatformFeatureSchema),
} as const;
